import { Component } from '@angular/core';

import { environment } from '../../environments/environment';

@Component({
  template: `
    <div layout-centered layout-vertical>
      <rt-icon name="search" size="large-x"></rt-icon>
      <rt-heading variant="heading large-xx" margin-top-small-x>
        {{ 'rto.common.page_not_found.title' | translate }}
      </rt-heading>
      <span>{{ 'rto.common.page_not_found.desc' | translate }}</span>
      <a rt-button variant="secondary" [href]="appAuthUrl" margin-top-small>
        {{ 'rto.common.page_not_found.button' | translate }}
      </a>
    </div>
  `,
  styles: [
    `
      :host {
        margin-top: 100px;
      }
    `,
  ],
})
export class RtoNotFoundComponent {
  public appAuthUrl: string = environment.appAuthUrl;
}
